/**
 * Swiper Slider Component
 */

class SwiperSlider {
  constructor(element) {
    this.slider = element;
    this.init();
  }

  init() {
    if (!this.slider || typeof Swiper === 'undefined') return;

    const slides = this.slider.querySelectorAll('.swiper-slide');

    this.swiperInstance = new Swiper(this.slider, {
      effect: "slide",
      loop: true,
      slidesPerView: 1,
      autoplay: false,
      observer: true,
      observeParents: true,

      loopedSlides: slides.length,
      watchSlidesProgress: true,

      pagination: {
        el: this.slider.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },

      navigation: {
        nextEl: this.slider.querySelector('.swiper-button-next'),
        prevEl: this.slider.querySelector('.swiper-button-prev'),
      },
    });
  }
}

function initSwiperSliders() {
  if (typeof Swiper === 'undefined') return;

  const sliders = document.querySelectorAll('.js-slider-02');
  sliders.forEach((slider) => new SwiperSlider(slider));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSwiperSliders);
} else {
  initSwiperSliders();
}

document.addEventListener('shopify:section:load', initSwiperSliders);
